import { Action, combineReducers } from '@ngrx/store';

import { Task } from '../../app/models/task.model';

import {
  ADD_TASK,
  CLEAR_TASKS,
  EDIT_TASK,
  REMOVE_TASK
} from '../actions';

export function taskListReducer(state: Task[] = [], action: Action) {
  switch (action.type) {
    case ADD_TASK:
      return [ ...state, action.payload.task ];
    case CLEAR_TASKS:
      return [];
    case EDIT_TASK:
      return state.map(task => {
        return task.key === action.payload.task.key
          ? action.payload.task
          : task;
      });
    case REMOVE_TASK:
      return state.filter(task => task.title !== action.payload.task.title);
    default:
      return state;
  }
}

export const notificationReducers = combineReducers({
  taskList: taskListReducer
});



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/reducers/notifications.ts